(function () {
  const STANDARD_VERSION_URL = window.__standardVersionURL || '/collections/custom-build-cars';
  let originalSpanHTML = null;
  let isSwapped = false;

  function isCustomizeProduct() {
    return window.__productHasCustomizeTag === true;
  }

  function allOptionsIncluded() {
    const variantInput = document.querySelector('[name="id"]');
    if (!variantInput) return false;
    return variantInput.value === variantInput.dataset.firstVariantId;
  }

  function getOrCreateMessage() {
    let msg = document.getElementById('standard-version-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.id = 'standard-version-msg';
      msg.style.cssText = 'display:none; margin-bottom:12px; font-size:0.9em; color:#6b7280;';
      msg.textContent = 'No custom options selected — view the standard model instead.';
      const productForm = document.querySelector('product-form') ||
                          document.querySelector('.product-form');
      productForm?.parentNode.insertBefore(msg, productForm);
    }
    return msg;
  }

  function documentClickInterceptor(e) {
    if (!isSwapped) return;
    const addToCartBtn = document.querySelector('[name="add"]');
    if (!addToCartBtn) return;
    if (!addToCartBtn.contains(e.target) && e.target !== addToCartBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = STANDARD_VERSION_URL;
  }

  function updateButton() {
    if (!isCustomizeProduct()) return;

    const addToCartBtn = document.querySelector('[name="add"]');
    if (!addToCartBtn) return;

    const span = addToCartBtn.querySelector('span');
    if (!span) return;

    const msg = getOrCreateMessage();

    if (allOptionsIncluded()) {
      if (!isSwapped) {
        originalSpanHTML = span.innerHTML;
      }
      isSwapped = true;
      msg.style.display = 'block';
      addToCartBtn.setAttribute('data-swapped', 'true');
      span.textContent = 'View Standard Model';
    } else {
      if (isSwapped && originalSpanHTML !== null) {
        span.innerHTML = originalSpanHTML;
        originalSpanHTML = null;
      }
      isSwapped = false;
      msg.style.display = 'none';
      addToCartBtn.removeAttribute('data-swapped');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const variantInput = document.querySelector('[name="id"]');
    if (variantInput && window.__firstVariantId) {
      variantInput.dataset.firstVariantId = window.__firstVariantId;
    }

    document.addEventListener('click', documentClickInterceptor, true);
    setTimeout(() => { updateButton(); }, 100);

    document.querySelector('.product-form')?.addEventListener('change', updateButton);

    if (variantInput) {
      const observer = new MutationObserver(() => updateButton());
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      variantInput.addEventListener('change', updateButton);
    }
  });
})();
